<!-- Footer Section start -->
<!-- <div class="copyright-section index-footer">
  <p>{{today | date:'y'}} copyright by themeforest powered by pixel strap</p>
</div> -->
<!-- Footer Section End -->
<!-- Tap on Top -->
<div [ngClass]="{'tap-top': showScroll}" (click)="onActivate()">
  <div>
    <i class="fa fa-angle-double-up"></i>
  </div>
</div>
<!-- Tap on Ends -->

<!-- Color Picker -->
<div class="color-picker" [class.open]="open" (click)="openPicker()">
  <!--   <a class="handle">
    <i class="fa fa-cog"></i>
  </a> -->
  <div class="sec-position">
    <div class="settings-header">
      <h3>Select Color:</h3>
    </div>
    <div class="section">
      <div class="colors o-auto">
        <a class="color-1" (click)="customizeColorScheme('color-1')"></a>
        <a class="color-2" (click)="customizeColorScheme('color-2')"></a>
        <a class="color-3" (click)="customizeColorScheme('color-3')"></a>
      </div>
    </div>
  </div>
</div>